
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { CTASection } from "@/sections/CTASection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CustomersLogosSection } from "@/sections/CustomersLogosSection";
import { ConversionSection } from "@/sections/ConversionSection";

const FigmaToPDF = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/FigmaToPDF"
        ogImage="/images/figma2pdf-og-image.jpg"
      />

      <MagicianSection
        title={t("page/FigmaToPDF:title")}
        subtitle={t("page/FigmaToPDF:subtitle")}
        magicianLogoFile="pdf"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/FigmaToPDF:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/figma-to-pdf-example.png",
          alt: "Figma to PDF converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/FigmaToPDF:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsAll"),
          },
          { iconType: "TV", text: t("section/conversion:badges.accuracy") },
        ]}
        elements={{
          from: {
            iconType: "FIGMA",
            image: "/images/figma2pdf-xd-preview.jpg",
            title: "Figma Demo Preview",
          },
          to: {
            iconType: "PDF",
            image: "/images/figma2pdf-pdf-preview.jpg",
            title: "PDF Import Demo Preview",
          },
        }}
      />
      <CustomersLogosSection />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.figmaToPDFPage")}
        href="#upload"
        isBetaFormat
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default FigmaToPDF;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/figma-to-pdf',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  